export default __webpack_public_path__ + "static/5-9481bbab522c9aa717f5d1825a99dd16.webp";